import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_how_many_suggestions_feedback_received_facility_addressed_2'

export const dataPointDefinition = {
  retracedId: 'yes_how_many_suggestions_feedback_received_facility_addressed_2',
  name: 'If yes, how many suggestions and feedback received by the facility addressed topics related to health & safety in the wo',
  description: '',
  meta: {
    slcpMeta: {
      key: 'wi-work-4',
      number: 'WI-WORK-3',
      dataType: 'numeric-whole',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[3],wi-work-2,Yes',
      machineShowHide: '[3],wi-work-2,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'NUMBER',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-work-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 37040,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
